export const NotificationType = {
    INVOICE_ISSUED: 'invoice_issued',
    PROGRAM_STARTING_SOON: 'program_starting_soon',
    MAINTENANCE_ALERT: 'maintenance_alert',
    SYSTEM_ANNOUNCEMENT: 'system_announcement',
} as const;
export type NotificationTypeTypes = typeof NotificationType[keyof typeof NotificationType];